/* istanbul ignore file */
import type { IRegion } from './models';

export const regionsDictionary: IRegion[] = [
    {
        id: 'msc',
        label: 'Москва и Московская область',
        heading: 'Москве и Московской области',
        regions: ['077', '050'],
        enabled: true,
        tabindex: 10,
        subnames: ['Москва', 'Московская обл'],
    },
    {
        id: 'spb',
        label: 'Санкт-Петербург и Ленинградская область',
        heading: 'Санкт-Петербурге и Ленинградской области',
        regions: ['078', '047'],
        enabled: true,
        tabindex: 20,
        subnames: ['Санкт-Петербург', 'Ленинградская обл'],
    },
    {
        id: 'barnaul',
        label: 'Барнаул и Алтайский край',
        heading: 'Барнауле и Алтайском крае',
        regions: ['022'],
        enabled: true,
        tabindex: 21,
        subnames: ['Барнаул', 'Алтайский край'],
    },
    {
        id: 'vladivostok',
        label: 'Владивосток и Приморский край',
        heading: 'Владивостоке и Приморском крае',
        regions: ['025'],
        enabled: true,
        tabindex: 22,
        subnames: ['Владивосток', 'Приморский край'],
    },
    {
        id: 'vladimir',
        label: 'Владимир и Владимирская область',
        heading: 'Владимире и Владимирской области',
        regions: ['033'],
        enabled: true,
        tabindex: 23,
        subnames: ['Владимир', 'Владимирская область'],
    },
    {
        id: 'volgograd',
        label: 'Волгоград и Волгоградская область',
        heading: 'Волгограде и Волгоградской области',
        regions: ['034'],
        enabled: true,
        tabindex: 24,
        subnames: ['Волгоград', 'Волгоградская область'],
    },
    {
        id: 'voronezh',
        label: 'Воронеж и Воронежская область',
        heading: 'Воронеже и Воронежской области',
        regions: ['036'],
        enabled: true,
        tabindex: 25,
        subnames: ['Воронеж', 'Воронежская область'],
    },
    {
        id: 'ekaterinburg',
        label: 'Екатеринбург и Свердловская область',
        heading: 'Екатеринбурге и Свердловской области',
        regions: ['066'],
        enabled: true,
        tabindex: 30,
        subnames: ['Екатеринбург', 'Екатеринбургская обл', 'Свердловская обл'],
    },
    {
        id: 'izhevsk',
        label: 'Ижевск и Удмуртская республика',
        heading: 'Ижевске и Удмуртской республике',
        regions: ['018'],
        enabled: true,
        tabindex: 34,
        subnames: ['Ижевск', 'Удмуртская республика'],
    },
    {
        id: 'irkutsk',
        label: 'Иркутск и Иркутская область',
        heading: 'Иркутске и Иркутской области',
        regions: ['038'],
        enabled: true,
        tabindex: 35,
        subnames: ['Иркутск', 'Иркутская область'],
    },
    {
        id: 'kazan',
        label: 'Казань и Республика Татарстан',
        heading: 'Казани и Республике Татарстан',
        regions: ['016'],
        enabled: true,
        tabindex: 40,
        subnames: ['Казань', 'Казанская обл'],
    },
    {
        id: 'kaliningrad',
        label: 'Калининград и Калининградская область',
        heading: 'Калининграде и Калининградской области',
        regions: ['039'],
        enabled: true,
        tabindex: 41,
        subnames: ['Калининград', 'Калининградская область'],
    },
    {
        id: 'kemerovo',
        label: 'Кемерово и Кемеровская область',
        heading: 'Кемерово и Кемеровской области',
        regions: ['042'],
        enabled: true,
        tabindex: 42,
        subnames: ['Кемерово', 'Кемеровская область'],
    },
    {
        id: 'novokuznetsk',
        label: 'Новокузнецк',
        heading: 'Новокузнецке',
        regions: ['042'],
        enabled: true,
        tabindex: 43,
        subnames: ['Новокузнецк'],
    },
    {
        id: 'kaluga',
        label: 'Калуга и Калужская область',
        heading: 'Калуге и Калужской области',
        regions: ['040'],
        enabled: true,
        tabindex: 45,
        subnames: ['Калуга', 'Калужская область'],
    },
    {
        id: 'krasnodar',
        label: 'Краснодар и Краснодарский край',
        heading: 'Краснодаре и Краснодарском крае',
        regions: ['023'],
        enabled: true,
        tabindex: 50,
        subnames: ['Краснодарская обл', 'Краснодар', 'Краснодарский кр', 'Адыгея'],
    },
    {
        id: 'krasnoyarsk',
        label: 'Красноярск и Красноярский край',
        heading: 'Красноярске и Красноярском крае',
        regions: ['024'],
        enabled: true,
        tabindex: 60,
        subnames: ['Красноярск', 'Красноярская обл', 'Красноярский кр'],
    },
    {
        id: 'nizhnovgorod',
        label: 'Нижний Новгород и Нижегородская область',
        heading: 'Нижнем Новгороде и Нижегородской области',
        regions: ['052'],
        enabled: true,
        tabindex: 70,
        subnames: ['Нижний Новгород', 'Нижегородская обл'],
    },
    {
        id: 'novosib',
        label: 'Новосибирск и Новосибирская область',
        heading: 'Новосибирске и Новосибирской области',
        regions: ['054'],
        enabled: true,
        tabindex: 80,
        subnames: ['Новосибирск', 'Новосибирская обл'],
    },
    {
        id: 'omsk',
        label: 'Омск и Омская область',
        heading: 'Омске и Омской области',
        regions: ['055'],
        enabled: true,
        tabindex: 85,
        subnames: ['Омск', 'Омская область'],
    },
    {
        id: 'orenburg',
        label: 'Оренбург и Оренбургская область',
        heading: 'Оренбурга и Оренбургской области',
        regions: ['056'],
        enabled: true,
        tabindex: 86,
        subnames: ['Оренбург', 'Оренбургская область'],
    },
    {
        id: 'perm',
        label: 'Пермь и Пермский край',
        heading: 'Перми и Пермском крае',
        regions: ['059'],
        enabled: true,
        tabindex: 90,
        subnames: ['Пермь', 'Пермская обл', 'Пермский кр'],
    },
    {
        id: 'rostovnadonu',
        label: 'Ростов-на-Дону и Ростовская область',
        heading: 'Ростове-на-Дону и Ростовской области',
        regions: ['061'],
        enabled: true,
        tabindex: 100,
        subnames: ['Ростов на Дону', 'Ростов-на-Дону', 'Ростовская обл'],
    },
    {
        id: 'samara',
        label: 'Самара и Самарская область',
        heading: 'Самаре и Самарской области',
        regions: ['063'],
        enabled: true,
        tabindex: 110,
        subnames: ['Самара', 'Самарская обл'],
    },
    {
        id: 'saratov',
        label: 'Саратов и Саратовская область',
        heading: 'Саратове и Саратовской области',
        regions: ['064'],
        enabled: true,
        tabindex: 111,
        subnames: ['Саратов', 'Саратовская область'],
    },
    {
        id: 'tomsk',
        label: 'Томск и Томская область',
        heading: 'Томске и Томской области',
        regions: ['070'],
        enabled: true,
        tabindex: 115,
        subnames: ['Томск', 'Томская область'],
    },
    {
        id: 'tula',
        label: 'Тула и Тульская область',
        heading: 'Туле и Тульской области',
        regions: ['071'],
        enabled: true,
        tabindex: 116,
        subnames: ['Тула', 'Тульская область'],
    },
    {
        id: 'tumen',
        label: 'Тюмень и Тюменская область',
        heading: 'Тюмени и Тюменской области',
        regions: ['072'],
        enabled: true,
        tabindex: 120,
        subnames: ['Тюмень', 'Тюменская обл'],
    },
    {
        id: 'ulyanovsk',
        label: 'Ульяновск и Ульяновская область',
        heading: 'Ульяновске и Ульяновской области',
        regions: ['073'],
        enabled: true,
        tabindex: 125,
        subnames: ['Ульяновск', 'Ульяновская область'],
    },
    {
        id: 'ufa',
        label: 'Уфа и Республика Башкортостан',
        heading: 'Уфе и Республике Башкортостан',
        regions: ['002'],
        enabled: true,
        tabindex: 130,
        subnames: ['Уфа', 'Уфимская обл', 'Башкортостан'],
    },
    {
        id: 'khabarovsk',
        label: 'Хабаровск и Хабаровский край',
        heading: 'Хабаровске и Хабаровском крае',
        regions: ['027'],
        enabled: true,
        tabindex: 140,
        subnames: ['Хабаровск', 'Хабаровский край'],
    },
    {
        id: 'chelyabinsk',
        label: 'Челябинск и Челябинская область',
        heading: 'Челябинске и Челябинской области',
        regions: ['074'],
        enabled: true,
        tabindex: 150,
        subnames: ['Челябинск', 'Челябинская область'],
    },
    {
        id: 'yaroslavl',
        label: 'Ярославль и Ярославская область',
        heading: 'Ярославле и Ярославской области',
        regions: ['076'],
        enabled: true,
        tabindex: 160,
        subnames: ['Ярославль', 'Ярославская область'],
    },
    {
        id: 'saransk',
        label: 'Саранск и Республика Мордовия',
        heading: 'Саранске и Республике Мордовия',
        regions: ['013'],
        enabled: true,
        tabindex: 170,
        subnames: ['Саранск', 'Республика Мордовия'],
    },
    {
        id: 'cheboksary',
        label: 'Чебоксары и Республика Чувашия',
        heading: 'Чебоксарах и Республике Чувашия',
        regions: ['021'],
        enabled: true,
        tabindex: 180,
        subnames: ['Чебоксары', 'Республика Чувашия'],
    },
];
